import React from 'react'
import styles from './TableBodyLine.module.scss'
import cl from 'classnames'
import { TableBodyLineProps } from './TableBodyLine.types'
import { TableBodyLineCell } from './TableBodyLineCell'

const TableBodyLineComponent = (props: TableBodyLineProps) => {
  const {
    className,
    cells,
    isExpanded,
    expandComponent,
    containerProps: {
      className: containerClassName,
      ...containerRestProps
    } = {},
    ...rest
  } = props

  return (
    <div
      className={cl(styles.container, {
        [styles.expanded]: isExpanded
      }, containerClassName)}
      {...containerRestProps}
    >
      <div
        className={cl(styles.tableLine, className)}
        {...rest}
      >
        {cells.map((cell, index) => {
          return (
            <TableBodyLineCell
              key={index}
              {...cell}
            />
          )
        }
        )}
      </div>
      {isExpanded && expandComponent}
    </div>
  )
}

const TableBodyLine = TableBodyLineComponent
export { TableBodyLine }
